import { WeatherConstraint } from 'types/models/WeatherConstraintDto';

export const colorCell = (
  weatherConstraints: WeatherConstraint[] | undefined,
  measurement: string
) => {
  return {
    color: weatherConstraints?.some(
      (constraint) => constraint.measurement === measurement
    )
      ? 'green'
      : undefined,
  };
};
